/*
 * Copyright (c) 2000-2018 Northwest Evaluation Association ~ All rights reserved.
 */

import { ProductNames, ValidThemesByProduct, DefaultThemesByProduct } from './renderer-constants'

export default class ThemeDefinitionModel {
  constructor (product, theme) {
    let productType = (product || '').toLowerCase()

    if (!product || !Object.values(ProductNames).includes(productType)) {
      throw new Error(`Invalid product "${product}"`)
    }

    let whichTheme = theme || ''

    // We like STATE better so we swap to it internally when we parse items
    if (productType === ProductNames.ACADEMIC_PROFICIENCY_NWEA) {
      productType = ProductNames.STATE
    }

    if (
      whichTheme !== '' &&
      ValidThemesByProduct[productType].length > 0 &&
      !ValidThemesByProduct[productType].some(t => t.identifier === whichTheme)
    ) {
      throw new Error(`Theme ${theme} is not valid for ${product}`)
    }

    if (whichTheme === '') {
      whichTheme = DefaultThemesByProduct[productType]
    }

    this.product = productType
    this.theme = whichTheme
  }
}
